import { render, staticRenderFns } from "./BasicPageSlider.vue?vue&type=template&id=3a08d141&scoped=true&"
import script from "./BasicPageSlider.vue?vue&type=script&lang=js&"
export * from "./BasicPageSlider.vue?vue&type=script&lang=js&"
import style0 from "./BasicPageSlider.vue?vue&type=style&index=0&id=3a08d141&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a08d141",
  null
  
)

export default component.exports